import { extractOperation } from './tracing';
import { logFetchApdex, logFetchError } from './apdex';
import { logFetchConnectionState } from './Logger/semanticMetrics';

export function instrumentFetch() {
  const windowFetch = window.fetch;

  window.fetch = async (...args) => {
    logFetchConnectionState();

    const request = new Request(...args);
    const what = extractOperation(request);

    return (async function retry(retries = 3): Promise<Response> {
      try {
        const start = Date.now();
        const response = await windowFetch(request.clone());
        const duration = Date.now() - start;
        if (response.status >= 500) logFetchError(what);
        else {
          logFetchApdex(what, duration);

          if (request.url === 'https://generic.wg.spotify.com/s4x-me/v0/me') {
            logFetchApdex('fetch.s4x-me/v0/me', duration);
          }
        }
        return response;
      } catch (error) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
        const potentialNetworkError = error?.name === 'TypeError';

        if (retries > 0 && potentialNetworkError) {
          await new Promise(resolve => setTimeout(resolve, 300)); // delay
          return retry(retries - 1);
        }

        logFetchError(what);
        throw error;
      }
    })();
  };
}
